import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function PrivateRoute() {
  const { currentUser } = useAuth();
  const location = useLocation();
  
  return currentUser ? (
    <Outlet />
  ) : (
    <Navigate
      to="/login"
      replace
      state={{ returnTo: `${location.pathname}${location.search}` }}
    />
  );
}

export default PrivateRoute;
